import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';
import { I18nModule } from '@softline/ui-core';

@Component({
  selector: 'soft-field-ok-artstamm-master-view',
  imports: [CommonModule, I18nModule],
  templateUrl: './artstamm.master-view.html',
  styleUrls: ['./artstamm.master-view.css'],
})
export class ArtstammMasterView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
